import { forwardRef, useState } from "react";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { Skeleton } from "shared/ui/shadcn/skeleton";
import { TIME_INTERVALS } from "shared/lib/constants/time";

interface CircleCommunityIframePropsI extends PropsWithClassNameI {
  iframeClassName?: string;
  communityURL: string;
  urlToDisplay: string;
  accessToken?: string | null;
}

const PostSkeleton = () => (
  <Skeleton className="h-[500px]  rounded-lg bg-white" />
);

const CircleIframeLoadingState = () => (
  <div className="flex h-[800px] w-full gap-5">
    <Skeleton className="h-[778px] w-[266px] rounded-lg bg-white" />
    <div className="flex w-[639px] flex-col gap-5">
      <Skeleton className="h-[120px]  rounded-lg bg-white" />
      <PostSkeleton />
      <PostSkeleton />
      <PostSkeleton />
    </div>
    <Skeleton className="w-[342px] rounded-lg bg-white" />
  </div>
);

export const CircleCommunityIframe = forwardRef<
  HTMLIFrameElement | null,
  CircleCommunityIframePropsI
>(
  (
    { className, iframeClassName, communityURL, urlToDisplay, accessToken },
    ref
  ) => {
    const [isReadyToDisplay, setIsReadyToDisplay] = useState(
      accessToken != null
    );

    const togglePendingStateOff = () => {
      // Artificially delay hiding skeleton, because it takes some time to load
      // all assets to eventually show salesfloor in an iframe
      setTimeout(() => {
        setIsReadyToDisplay(true);
      }, TIME_INTERVALS.ONE_SECOND * 0.7);
    };

    return (
      <div className={className}>
        {!isReadyToDisplay && <CircleIframeLoadingState />}

        {accessToken !== null && (
          <iframe
            ref={ref}
            onLoad={togglePendingStateOff}
            className={iframeClassName}
            allow={`camera ${communityURL}; microphone ${communityURL}`}
            src={
              accessToken
                ? `${communityURL}/session/cookies?access_token=${accessToken}`
                : urlToDisplay
            }
          />
        )}
      </div>
    );
  }
);

CircleCommunityIframe.displayName = "CircleCommunityIframe";
